import type NetworkInfo from '../schema/NetworkInfo';

/**
 * Method that gives the current user network info.
 */
export default function (): NetworkInfo {
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    const nav = navigator as any;
    const connection = nav?.connection || nav?.mozConnection || nav?.webkitConnection;
    return connection
        ? {
              type: connection?.type,
              effectiveType: connection?.effectiveType,
              downlink: connection?.downlink,
              rtt: connection?.rtt,
              saveData: connection?.saveData,
          }
        : null;
}
